export const ALL_PURCHASERS_SCOPE = "all";
export const SPECIFIC_PURCHASER_SCOPE = "specific";
export const DEFAULT_PRICE_LABEL = "Base Price";

const LEGACY_DEFAULT_PRICE_LABELS = new Set([
  "all purchasers",
  "default purchasers",
  "default price",
]);

export function productPriceAppliesToLabel(
  appliesTo: string | null | undefined,
): string | null {
  if (appliesTo == null) return null;
  const trimmed = appliesTo.trim();
  if (LEGACY_DEFAULT_PRICE_LABELS.has(trimmed.toLowerCase())) {
    return DEFAULT_PRICE_LABEL;
  }
  return trimmed;
}

export interface ProductPriceAddFormValues {
  appliesTo: string;
  purchaserId: number | null;
  productPrice: string;
  startDate: string;
  notes: string;
}

export const EMPTY_PRODUCT_PRICE_ADD_VALUES: ProductPriceAddFormValues = {
  appliesTo: ALL_PURCHASERS_SCOPE,
  purchaserId: null,
  productPrice: "",
  startDate: "",
  notes: "",
};

export interface ProductPricePurchaserOption {
  purchaserId: number;
  purchaserName: string;
  purchaserKey: string;
}

function todayIsoDate(): string {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

export function productPriceMinDate(): string {
  return todayIsoDate();
}

export function productPriceNextDate(isoDate: string): string {
  const [year, month, day] = isoDate.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + 1);
  const nextMonth = String(date.getUTCMonth() + 1).padStart(2, "0");
  const nextDay = String(date.getUTCDate()).padStart(2, "0");
  return `${date.getUTCFullYear()}-${nextMonth}-${nextDay}`;
}

export function productPriceScopeKey(
  appliesTo: string,
  purchaserId: number | null,
): string | null {
  if (appliesTo === SPECIFIC_PURCHASER_SCOPE) {
    return purchaserId != null && Number(purchaserId) > 0
      ? String(purchaserId)
      : null;
  }
  return ALL_PURCHASERS_SCOPE;
}

export function priceStartDay(value: string | null | undefined): string | null {
  const match = /^(\d{4}-\d{2}-\d{2})/.exec(value ?? "");
  return match?.[1] ?? null;
}

export function priceHistoryStartsOn(
  items: ReadonlyArray<{ effectiveFrom: string | null }>,
  day: string,
): boolean {
  return items.some((item) => priceStartDay(item.effectiveFrom) === day);
}
